module.exports = __webpack_public_path__ + "img/Ventuar_Metal Broadsword.9ab05fca.png";